import React, { memo } from "react";
import { FormattedNumber } from "ui/common/Formatted";

const FormattedPrice: typeof FormattedNumber = ({ value, ...rest }) => (
  // eslint-disable-next-line react/style-prop-object
  <FormattedNumber style="currency" currency="USD" value={value} {...rest} />
);

export default memo(FormattedPrice);
